import { apiClient, Auth } from '@/shared/api'

import { THostContractActionsCount } from '../model/schema'

export const getHostContractActionsCount = async () => {
  const response = await apiClient.get<THostContractActionsCount>({
    endpoint: `/host/contracts/masters/actions/count`,
    auth: Auth.REQUIRED,
  })

  return response
}
